import React, { useEffect, useMemo, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import FieldInput from 'shared/components/FieldInput'
import { getNestedProperty } from '../../helpers/getNestedProperty'
import { validateSpecifyErrors, validateCountryErrors, validateProvinceOrStateErrors } from 'shared/helpers/validators'
import { StatusSelectInputWrapper } from '../StatusSelectInputWrapper'
import {
  getStateListAction,
  getProvinceListAction,
  getCountryListAction,
  reduceTerritoryMap,
} from '../../../redux/reducers/apiReducers/stateProvinceListReducer'

const CountryProvinceSelect = ({
  t,
  i18n,
  reduxAppProperty,
  changeObjectPropertyAction,
  validate,
  formErrors,
  setFormErrors,
  setIsError,
}) => {
  const [isFocussed, SetIsFocussed] = useState(false)

  const dispatch = useDispatch()

  const { provinceOrState, country, specify } = useSelector((state) => getNestedProperty(state.app, reduxAppProperty))

  const { states, provinces, countries } = useSelector((state) => state.stateProvince)
  const { authenticated } = useSelector((state) => state.authentication)

  useEffect(() => {
    if (!authenticated) {
      return
    }
    try {
      dispatch(getProvinceListAction())
      dispatch(getStateListAction())
      dispatch(getCountryListAction())
    } catch (error) {
      console.error(error)
      setIsError(error.toString())
    }
  }, [dispatch, setIsError, authenticated])

  const provincesSelect = useMemo(() => reduceTerritoryMap(provinces, i18n.language), [provinces, i18n.language])
  const statesSelect = useMemo(() => reduceTerritoryMap(states, i18n.language), [states, i18n.language])
  const countriesSelect = useMemo(() => reduceTerritoryMap(countries, i18n.language), [countries, i18n.language])

  const handleCountrySelect = (e) => {
    let selectedCountry = e.currentTarget.value
    changeObjectPropertyAction('country', selectedCountry)
    changeObjectPropertyAction('provinceOrState', '')
    changeObjectPropertyAction('specify', '')
    setFormErrors((prevFormErrors) => ({ ...prevFormErrors, provinceOrState: '', specify: '' }))

    validateCountry(selectedCountry)
  }

  const onBlurCountry = (val) => {}

  const handleProvinceOrStateSelect = (e) => {
    let selectedProvinceOrState = e.currentTarget.value
    changeObjectPropertyAction('provinceOrState', selectedProvinceOrState)
    validateProvinceOrState(selectedProvinceOrState)
  }

  const onBlurProvinceOrState = (e) => {
    let selectedProvinceOrState = e.currentTarget.value
    validateProvinceOrState(selectedProvinceOrState)
  }

  const handleChangeObjectPropertyAction = (fieldName) => (value) => {
    changeObjectPropertyAction(fieldName, value)
  }

  const validateCountry = (newCountry) => {
    const countryErrors = validateCountryErrors(newCountry)
    setFormErrors((prevFormErrors) => ({ ...prevFormErrors, country: countryErrors }))
  }

  const validateProvinceOrState = (newProvinceOrState) => {
    const provinceOrStateErrors = validateProvinceOrStateErrors(country, newProvinceOrState)
    setFormErrors((prevFormErrors) => ({ ...prevFormErrors, provinceOrState: provinceOrStateErrors }))
  }

  const validateSpecify = (specifyStr) => {
    const specifyErrors = validateSpecifyErrors(specifyStr)
    setFormErrors((prevFormErrors) => ({ ...prevFormErrors, specify: specifyErrors }))
  }

  return (
    <>
      {/* Country */}
      <StatusSelectInputWrapper
        isValid={formErrors.country === '' ? '' : !formErrors.country}
        errorMsg={formErrors.country}
        t={t}
        selectOptions={countriesSelect}
        label={t('shared.country_select')}
        customClasses={'fw-20'}
        id="country-select"
        name="country-select"
        type="text"
        isFocussed={isFocussed}
        aria-describedby="country-select"
        onChange={handleCountrySelect}
        // onBlur={onBlurCountry}
        onFocus={() => SetIsFocussed(true)}
        value={country}
      />

      {/* Specify */}
      {country === 'Other' && (
        <FieldInput
          id="countrySpecify"
          name="countrySpecify"
          type="text"
          customClasses={'fw-20'}
          aria-describedby="countrySpecify"
          autoComplete="off"
          maxLength="20"
          label={t('shared.specify')}
          t={t}
          value={specify}
          validate={validateSpecify}
          errorMsg={formErrors.specify}
          isValid={formErrors.specify === '' ? '' : !formErrors.specify}
          setIsError={setIsError}
          changeObjectPropertyAction={handleChangeObjectPropertyAction('specify')}
        />
      )}

      {/* Provinces if Canada is selected */}
      {country === 'Canada' && (
        <StatusSelectInputWrapper
          isValid={formErrors.provinceOrState === '' ? '' : !formErrors.provinceOrState}
          errorMsg={formErrors.provinceOrState}
          t={t}
          selectOptions={provincesSelect}
          label={t('shared.province_select')}
          customClasses={'fw-20'}
          id="province-select"
          name="province-select"
          type="text"
          isFocussed={isFocussed}
          aria-describedby="province-select"
          onChange={handleProvinceOrStateSelect}
          onBlur={onBlurProvinceOrState}
          onFocus={() => SetIsFocussed(true)}
          value={provinceOrState}
        />
      )}

      {/* States if USA is selected */}
      {country === 'USA' && (
        <StatusSelectInputWrapper
          isValid={formErrors.provinceOrState === '' ? '' : !formErrors.provinceOrState}
          errorMsg={formErrors.provinceOrState}
          t={t}
          selectOptions={statesSelect}
          label={t('shared.state_select')}
          customClasses={'fw-20'}
          id="province-state-select"
          name="province-state-select"
          type="text"
          isFocussed={isFocussed}
          aria-describedby="province-state-select"
          onChange={handleProvinceOrStateSelect}
          onBlur={onBlurProvinceOrState}
          onFocus={() => SetIsFocussed(true)}
          value={provinceOrState}
        />
      )}
    </>
  )
}

export default withTranslation('common')(CountryProvinceSelect)
